export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-700 via-emerald-700 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/dd66c989-a8cb-410a-90a3-3c62c8bb95ba.png"
              alt="Company Logo"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <h3 className="text-lg font-semibold mb-2">Central Technology Group</h3>
            <p className="text-gray-200 text-sm leading-relaxed">
              Connecting technology vendors with global markets through strategic partnerships and innovative marketing solutions.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partnerships')}
                  className="text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  Partnerships
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">
              Services
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-200 text-sm">Market Entry Strategy</li>
              <li className="text-gray-200 text-sm">Channel Development</li>
              <li className="text-gray-200 text-sm">Marketing Solutions</li>
              <li className="text-gray-200 text-sm">Brand Positioning</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">
              Connect
            </h4>
            <div className="space-y-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
              >
                <i className="ri-linkedin-fill text-lg"></i>
                LinkedIn
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
                Twitter
              </a>
              <a
                href="mailto:info@centraltechgroup.net"
                className="flex items-center gap-3 text-gray-200 hover:text-white transition-colors cursor-pointer text-sm"
              >
                <i className="ri-mail-fill text-lg"></i>
                Email
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm">
              © 2024 Central Technology Group. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
